import TrueFalseSwitchComponent from '../custom_components/TrueFalseSwitch'
import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'

type EmojiRatingProps = FormikFieldProps & { [key: string]: string | boolean }

const TrueFalseSwitch = ({ name, validate, onValueChanged, currentValue, disabled, ...props }: EmojiRatingProps): JSX.Element => {
  return (
    <Field data-e2e-true-false-switch name={name} validate={validate}>
      {({ field, form: { setFieldValue } }: FieldProps) => (
        <TrueFalseSwitchComponent
          currentValue={!disabled ? field.value : currentValue}
          onValueChanged={(v) => {
            setFieldValue(name, v)
          }}
          disabled={disabled as boolean}
          {...props}
        />
      )}
    </Field>
  )
}

export default TrueFalseSwitch
